/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DraftKingsOverlaySlateListQueryVariables = {|
  playerId: string
|};
export type DraftKingsOverlaySlateListQueryResponse = {|
  +playerInfo: ?{|
    +sport: ?{|
      +name: string
    |},
    +playerDkId: number,
    +headshotUrl: ?string,
  |},
  +activeSlatePlayersForDkPlayer: ?$ReadOnlyArray<?{|
    +slatePlayer: ?{|
      +id: string,
      +player: {|
        +name: string
      |},
      +salary: number,
      +slateCompetition: ?{|
        +slate: {|
          +suffix: ?string,
          +prettyStartTime: ?string,
          +gameType: {|
            +name: string,
            +sport: {|
              +name: string
            |},
          |},
        |}
      |},
    |},
    +selected: ?boolean,
  |}>,
|};
export type DraftKingsOverlaySlateListQuery = {|
  variables: DraftKingsOverlaySlateListQueryVariables,
  response: DraftKingsOverlaySlateListQueryResponse,
|};
*/


/*
query DraftKingsOverlaySlateListQuery(
  $playerId: ID!
) {
  playerInfo(playerId: $playerId) {
    sport {
      name
      id
    }
    playerDkId
    headshotUrl
    id
  }
  activeSlatePlayersForDkPlayer(playerId: $playerId) {
    slatePlayer {
      id
      player {
        name
        id
      }
      salary
      slateCompetition {
        slate {
          suffix
          prettyStartTime
          gameType {
            name
            sport {
              name
              id
            }
            id
          }
          id
        }
        id
      }
    }
    selected
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "playerId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "playerId",
    "variableName": "playerId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = [
  (v2/*: any*/)
],
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "SportType",
  "kind": "LinkedField",
  "name": "sport",
  "plural": false,
  "selections": (v3/*: any*/),
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "playerDkId",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "headshotUrl",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "salary",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "suffix",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "prettyStartTime",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "selected",
  "storageKey": null
},
v12 = [
  (v2/*: any*/),
  (v7/*: any*/)
],
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "SportType",
  "kind": "LinkedField",
  "name": "sport",
  "plural": false,
  "selections": (v12/*: any*/),
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DraftKingsOverlaySlateListQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PlayerType",
        "kind": "LinkedField",
        "name": "playerInfo",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SlatePlayerQuickAddType",
        "kind": "LinkedField",
        "name": "activeSlatePlayersForDkPlayer",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SlatePlayerType",
            "kind": "LinkedField",
            "name": "slatePlayer",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "PlayerType",
                "kind": "LinkedField",
                "name": "player",
                "plural": false,
                "selections": (v3/*: any*/),
                "storageKey": null
              },
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SlateCompetitionType",
                "kind": "LinkedField",
                "name": "slateCompetition",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SlateType",
                    "kind": "LinkedField",
                    "name": "slate",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      (v10/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "GameTypeType",
                        "kind": "LinkedField",
                        "name": "gameType",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v11/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DraftKingsOverlaySlateListQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PlayerType",
        "kind": "LinkedField",
        "name": "playerInfo",
        "plural": false,
        "selections": [
          (v13/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SlatePlayerQuickAddType",
        "kind": "LinkedField",
        "name": "activeSlatePlayersForDkPlayer",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SlatePlayerType",
            "kind": "LinkedField",
            "name": "slatePlayer",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "PlayerType",
                "kind": "LinkedField",
                "name": "player",
                "plural": false,
                "selections": (v12/*: any*/),
                "storageKey": null
              },
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SlateCompetitionType",
                "kind": "LinkedField",
                "name": "slateCompetition",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SlateType",
                    "kind": "LinkedField",
                    "name": "slate",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      (v10/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "GameTypeType",
                        "kind": "LinkedField",
                        "name": "gameType",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v13/*: any*/),
                          (v7/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v7/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v7/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v11/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "783fcf66b035809b18d9b47ee8669f68",
    "id": null,
    "metadata": {},
    "name": "DraftKingsOverlaySlateListQuery",
    "operationKind": "query",
    "text": "query DraftKingsOverlaySlateListQuery(\n  $playerId: ID!\n) {\n  playerInfo(playerId: $playerId) {\n    sport {\n      name\n      id\n    }\n    playerDkId\n    headshotUrl\n    id\n  }\n  activeSlatePlayersForDkPlayer(playerId: $playerId) {\n    slatePlayer {\n      id\n      player {\n        name\n        id\n      }\n      salary\n      slateCompetition {\n        slate {\n          suffix\n          prettyStartTime\n          gameType {\n            name\n            sport {\n              name\n              id\n            }\n            id\n          }\n          id\n        }\n        id\n      }\n    }\n    selected\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '5a5cc102b202b58da9b9af6cdbdcde10';

module.exports = node;
